import React from "react";
import { useSelector } from "react-redux";
import Tooltip from "components/design-system/tooltip";
import Price from "components/source/grid/price";
import { showDecimal } from "helpers/price-helper";
import { normalizePrice } from "helpers/PricingHelper";
import { Faq } from "routes";

const ReservePrice = () => {
  const staticProduct = useSelector(state => state.staticProduct);
  const reservePricing = useSelector(state => state.pdp?.reserve?.pricing?.price || []);
  const reservePriceMap = Object.fromEntries(
    reservePricing.map(({ id, value, discount }) => [id, { value, discount }])
  );

  const msrp = reservePriceMap["msrp"]?.value || staticProduct.msrp;
  const salePrice = reservePriceMap["memberrental"]?.value;
  const price = reservePriceMap["rental"]?.value;
  const discount = reservePriceMap["memberrental"]?.discount;

  const tooltipContent = (
    <div className="w-64 p-2">
      This number represents the “Original Retail” or “Comparable Value” price. Items may be in the rental rotation for
      multiple seasons after these prices are set. For more info on these prices, see our{" "}
      <a href={Faq.purchasePricing} rel="noopener noreferrer" target="_blank">
        FAQs
      </a>
    </div>
  );

  return (
    <div>
      <div className="flex">
        {salePrice ? (
          <>
            <div className="mr-2">
              {`Reserve for `}
              <span className="semibold">{normalizePrice(salePrice)}</span>
            </div>
            <div className="mr-2 line-through text-lightGray">{`${normalizePrice(price)}`}</div>
          </>
        ) : (
          <div className="mr-2">
            {`Reserve for `}
            <span className="semibold">{normalizePrice(price)}</span>
          </div>
        )}
        <div className="mr-2 flex pr-2 border-l border-offWhite">
          <div className="text-darkerGray ml-2 flex gap-1">
            <Price
              amount={msrp}
              currencyCode="USD"
              currencyCodeClassName="hidden @[275px]/label:inline"
              showDecimal={showDecimal(msrp)}
            />
            <span>original retail</span>
            <Tooltip className="ml-1 inline-flex items-center" position="left" tooltipContent={tooltipContent} />
          </div>
        </div>
      </div>
      {discount && <p className="text-sm mt-1 text-tealGreen italic">{`${discount * 100}% Membership Discount`}</p>}
    </div>
  );
};

export default ReservePrice;
